<template>
  <div>
    <img class="crisp-image" src="@/assets/images/ico062.svg" alt="Wait for Results">
    <text-string label-id="txt374" class="m-b-10"/>
    <text-string label-id="txt375"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-hipres-step-three"
  }
</script>

<style scoped>

</style>